import { AbstractControl } from '@angular/forms';

export const maxFilesValidator = (maxFiles: number) => {
    return (control: AbstractControl): { [key: string]: any } | null => {
        return control.value && control.value.length > maxFiles ? { 'maxFiles': maxFiles } : null;
    };
};

export const maxSizeValidator = (maxSize: number) => {
    return (control: AbstractControl): { [key: string]: any } | null => {

        let totalSize = 0;
        if (control.value) {
            control.value.forEach((file: File) => {
                totalSize += file.size;
            });
        }

        return control.value && totalSize > (maxSize * 1.024) ? { 'maxSize': maxSize } : null;
    };
};

export const mimeTypeExtensionValidator = (mimeTypes: string[]) => {
    return (control: AbstractControl): { [key: string]: any } | null => {

        const invalidFiles = [];
        if (control.value) {
            control.value.forEach((file: File) => {
                if (mimeTypes.indexOf(file.type) === -1) {
                    invalidFiles.push(file.name);
                }
            });
        }

        return control.value && invalidFiles.length > 0 ? { 'invalidFileExtension': invalidFiles } : null;
    };
};
